import ReactGA from 'react-ga'
import mixpanel from 'mixpanel-browser'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { hotjar } from 'react-hotjar'

import * as constants from '../constants'
import logger from 'utils/logger'

const shouldTrack = () => constants.ENV !== 'development'
const sentryConfig = () => ({
  dsn: constants.SENTRY_DSN,
  environment: constants.ENV,
  integrations: [new Integrations.BrowserTracing()],
  release: constants.RELEASE_VERSION
    ? 'rfp-web@' + constants.RELEASE_VERSION
    : undefined,
  normalizeDepth: 6,
})

export enum AnalyticsEvent {
  TestEvent = 'Test Event',
  OpenCarrierBids = 'Open Carrier Bids',
  CloseCarrierBids = 'Close Carrier Bids',
}

export interface EventArgs {
  category: AnalyticsEvent
  action: string
  label?: string
  value?: number
  nonInteraction?: boolean
  transport?: 'beacon' | 'xhr' | 'image'
}

let isUserSet = false

export default {
  init: () => {
    if (!shouldTrack()) return
    Sentry.init(sentryConfig())
    mixpanel.init(constants.MIXPANEL_TOKEN)
    ReactGA.initialize(constants.GA_TRACKING_ID)
    ReactGA.pageview(window.location.pathname + window.location.search)
    hotjar.initialize(constants.HOTJAR_ID, constants.HOTJAR_VERSION)
    logger.init()
  },
  setUser: (user: any) => {
    if (!shouldTrack() || isUserSet) return

    Sentry.setUser(user)
    ReactGA.set(user)
    mixpanel.register(user)
    logger.setUser(user)

    isUserSet = true
  },
  track: (event: AnalyticsEvent, props: any | null) => {
    if (!shouldTrack()) return
    mixpanel.track(event, props)
  },
  event: (args: EventArgs) => {
    if (!shouldTrack()) return
    ReactGA.event(args)
  },
}
